import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';
import { executeSyncRequest } from '../../../../../share/util/api/syncRequest';
import apiService from '../../../../../share/util/api/service';
import session from '../../../../../share/session';
import util from '../../../../../share/util/utils';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import WS45Dialog from '../Requirement045Dialog';
import requirement045Utils from './Requirement045Utils';

/**
 * [wsp] Standby 準備処理 
 * @param {instance} self 呼び出し元this
 */
export async function initDataMonitor(self) {
  try {
    self.isLoading = self.isNonDefaultSession = self.isStartToggle = true;
    self.dataMonitorTemporaryResponse = null; // レスポンス情報初期化
    self.dataMonitorPhase = 'handleInitDataMonitor';
    //バックエンドAPI POST,GET
    const token = session.getToken();
    self.dataMonitorTemporaryResponse = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'standby'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(true); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );
    // 正常コールバック
    if (self.dataMonitorTemporaryResponse) {
      if (self.dataMonitorTemporaryResponse.data.status === REQUEST_STATUS_COMPLETED) {
        // 正常終了
        await self.monitor();
      } else {
        throw new Error('Unexpected error occurred: ', self.dataMonitorTemporaryResponse.data);
      }
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.INIT_DATA_MONITOR, error, self);
  }
}

/**
 * [obd] オンボードシステムテスト
 * @param {instance} self 呼び出し元this
 */
export async function obdOnboardSystemTest(self) {
  try {
    self.isLoading = true;
    self.dataMonitorTemporaryResponse = null; // レスポンス情報初期化
    self.dataMonitorPhase = 'handleOnboardSystemTest';
    self.dataMonitorTemporaryResponse = await requirement045Utils.doPolling(
      self,
      apiService.OBD,
      {},
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/systems/${self.systemNo}/systemTest`,
      `/netApps/${self.netAppId}/requests/`
    );
    // 正常コールバック
    if (self.dataMonitorTemporaryResponse) {
      switch (self.dataMonitorTemporaryResponse.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 正常終了 : 
          switch (self.workSupportId) {
            //[obd] オンボードモニタテストへ遷移
            case 4501:
              self.standbyObdOnboardMonitorTest();
              break;
            //[wsp] Monitor モニターへ遷移
            case 12501:
              self.initDataMonitor();
              break;
          }
          break;
        case REQUEST_STATUS_FAILED: {
          // 異常終了
          const errorCode = self.dataMonitorTemporaryResponse.data.error_code;
          if (errorCode === "execute_error") {
            self.isLoading = false;
            self.dialog.phase = WS45Dialog.PHASE.EVAPO_LEAK_TEST_FAILURE;
          } else {
            throw new Error(`Invalid error_code: ${errorCode}`);
          }
          break;
        }
        default:
          throw new Error(`Invalid status: ${self.dataMonitorTemporaryResponse.data.status}`);
      }
    }
  } catch (error) {
    self.isLoading = false;
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.ONBOARD_SYSTEM_TEST, error, self);
  }
}

/**
 * [obd] オンボードモニタテスト
 * @param {instance} self 呼び出し元this
 */
export async function standbyObdOnboardMonitorTest(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doPolling(
      self,
      apiService.OBD,
      {
        is_called_from_work_support: true,
        inquiry_mids: [0x06]
      },
      `/netApps/${self.netAppId}/obd/${self.obdDataId}/systems/${self.systemNo}/onboardMonitorTest`,
      `/netApps/${self.netAppId}/requests/`
    );
    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          self.standbyOnboardMeasuredId = response.data?.results?.measure_id;
          break;
        case REQUEST_STATUS_FAILED:
          self.standbyOnboardErrorCode = response.data?.error_code;
          if (!(self.standbyOnboardErrorCode === "" || self.standbyOnboardErrorCode === "not_support")) {
            throw new Error(`Invalid error_code: self.standbyOnboardErrorCode`);
          }
          break;
        default:
          throw new Error(`Invalid status: ${response.data.status}`);
      }
      await self.initDataMonitor();
    }
  } catch (error) {
    self.isLoading = false;
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.STANDBY_OBD_ONBOARD_MONITOR_TEST, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * [wsp] Monitor モニター
 * @param {instance} self 呼び出し元this
 */
export async function monitor(self) {
  try {
    self.isMonitorStarted = self.isLoading = true;
    self.dataMonitorTemporaryResponse = null; // レスポンス情報初期化
    self.dataMonitorPhase = 'handleMonitor';
    const token = session.getToken();
    //バックエンドAPI POST,GET
    self.dataMonitorTemporaryResponse = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'monitor',
        obd_data_id: self.obdDataId,
        system_no: self.systemNo
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(true); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );
    // 正常コールバック
    if (self.dataMonitorTemporaryResponse) {
      if (self.dataMonitorTemporaryResponse.data.status === REQUEST_STATUS_COMPLETED) {
        // 正常終了 : [wsp] 計測データ取得へ遷移
        self.measuredId = self.dataMonitorTemporaryResponse.data.user_data.measured_id.toString();
        self.monitoringInterval = self.dataMonitorTemporaryResponse.data.user_data.monitoring_interval_time;
        self.timestamp
          = self.dataMonitor.ws45MarkerInfo.baseTime
          = Math.floor(self.dataMonitorTemporaryResponse.data.user_data.timestamp);
        self.dataName = self.dataMonitorTemporaryResponse.data.user_data.data_name;
        await self.getMeasuredData();
      } else {
        throw new Error('Unexpected error occurred: ', self.dataMonitorTemporaryResponse.data);
      }
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.MONITOR, error, self);
  }
}

/**
 * [wsp] 計測データ取得
 * @param {instance} self 呼び出し元this
 */
export async function getMeasuredData(self) {
  try {
    if (self.dataMonitor.getMeasuredDataNumber === 0) {
      self.dialog.phase = WS45Dialog.PHASE.DATA_MONITOR_STARTED;
      self.isLoading = true;
    }
    if (self.isInterruption) {
      self.isLoading = true;
    }
    self.isEndToggle = false;
    self.isMeasureStated = true;
    self.dataMonitorTemporaryResponse = null; // レスポンス情報初期化
    self.dataMonitorPhase = 'handleGetMeasuredData';
    let endPoint = `/workSupports/${self.projectId}/${self.measuredId}?base_timestamp=${self.timestamp}&net_app_id=${self.netAppId}`;
    if (self.workSupportId === 4501) {
      const omtMeasureId = self.standbyOnboardMeasuredId ? self.standbyOnboardMeasuredId : "null";
      endPoint += `&obd_data_id=${self.obdDataId}&omt_measure_id=${omtMeasureId}`;
    }
    // バックエンドAPI GETのみ
    self.dataMonitorTemporaryResponse = await executeSyncRequest(
      self,
      async () => { return await apiService.getCall(apiService.WSP, endPoint); },
      // エラー発生のコールバック
      (errorType) => { errorType; self.validateErrorResult({ causeType: 8 }, false); }, // other error
      // GET API で正常レスポンスが返ってきた際の内容チェックはデフォルト処理を利用
      undefined,
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する
      (result) => { self.validateErrorResult(result, false); },
    );
    // 正常コールバック
    if (self.dataMonitorTemporaryResponse) {
      if (!self.isInterruption) {
        // データモニタ中断中でないかつ正常終了の場合
        await self.handleGetMeasuredData();
      } else {
        self.isLoading = false;
      }
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.GET_MEASURED_DATA, error, self);
  }
}

/**
 * [wsp] 計測データ取得(レスポンスに対する処理)
 * @param {instance} self 呼び出し元this
 */
export async function handleGetMeasuredData(self) {
  try {
    self.isLoading = false;
    // 正常コールバック
    const response = self.dataMonitorTemporaryResponse;
    if (response.data.project?.res_type === "ok") {
      // 正常終了
      if (response.data?.project?.test_result === "in_progress") {
        // 実行中の場合 : データモニタ表示更新
        await self.dataMonitor.update(
          response.data?.project?.monitor_items,
          response.data?.project?.timestamp,
          false
        );
        // スリープ後再度状況取得
        self.timestamp = response.data.project.timestamp;
        await util.sleep(self.monitoringInterval);
        await self.getMeasuredData();
        return;
      }
      // エバポリークテスト結果表示処理
      if (self.dtcStatusAvailabilityMask) {
        // レディネスコード対応か否か
        switch (response.data?.project.test_result) {
          case "completed":
            // 完了
            self.evapoLeakTestResult = self.$t(`individual.label_dtc_completion`);
            break;
          case "detected_failure":
            // 故障
            self.evapoLeakTestResult = self.$t(`individual.label_dtc_breakdown`);
            break;
          case "no_dtc":
            // DTCなし
            self.evapoLeakTestResult = self.$t(`individual.label_dtc_none`);
            break;
        }
      } else {
        // DTCなし
        self.evapoLeakTestResult = self.$t(`individual.label_dtc_none`);
      }
      self.dialog.phase = WS45Dialog.PHASE.EVAPO_LEAK_TEST_RESULT;
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.HANDLE_GET_MEASURED_DATA, error, self);
  }
}

export default {
  initDataMonitor,
  obdOnboardSystemTest,
  standbyObdOnboardMonitorTest,
  monitor,
  getMeasuredData,
  handleGetMeasuredData
};